import { TalentDisplay } from '../models/dtos';

export type TalentStatusFilter = 'active' | 'inactive' | 'all';

export const isTalentActive = (talent: TalentDisplay): boolean =>
    !talent.IsDeleted && talent.IsActive !== false;

export const filterTalentsByStatus = (
    talents: TalentDisplay[],
    filter: TalentStatusFilter,
): TalentDisplay[] => {
    if (filter === 'all')
        return talents;

    return talents.filter(talent => isTalentActive(talent) === (filter === 'active'));
};

export const getTalentActivityPeriodCount = (talent: TalentDisplay): number => {
    if (talent.ActivationHistory?.length)
        return talent.ActivationHistory.length;

    return talent.ActivatedDate ? 1 : 0;
};
